import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Box,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material'
import { themeNew } from 'styles/theme-new'
import {
  BeneficialOwnersType,
  BeneficialOwnersLegitimateReason,
} from 'services/cm-api/get-customer'

type BeneficialOwnersProps = {
  value: BeneficialOwnersType
  label: string
  onChange: (newValue: BeneficialOwnersType) => void
  isLoading: boolean
  reasonOptions: {
    label: string
    key: string
  }[]
}

function BeneficialOwners({
  value,
  label,
  onChange,
  isLoading,
  reasonOptions,
}: BeneficialOwnersProps) {
  const handleToggle = () => {
    if (isLoading) return

    if (value?.enabled) {
      // Turning off - set reason to null
      onChange({
        enabled: false,
        default_legitimate_reason: null,
      })
    } else {
      // Turning on - default to CDD
      onChange({
        enabled: true,
        default_legitimate_reason: 'CDD',
      })
    }
  }

  const handleReasonChange = (newReason: string) => {
    if (isLoading) return

    onChange({
      enabled: true,
      default_legitimate_reason: newReason as BeneficialOwnersLegitimateReason,
    })
  }

  const isEnabled = value?.enabled ?? false
  const currentReason = value?.default_legitimate_reason ?? 'CDD'

  return (
    <Stack spacing={1}>
      <FormControlLabel
        sx={{
          m: 0,
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem',
          },
        }}
        control={
          <Switch
            size="small"
            disabled={isLoading}
            color="default"
            style={{
              color: isEnabled
                ? themeNew.palette.success[500]
                : themeNew.palette.grey[600],
            }}
            checked={isEnabled}
            onChange={handleToggle}
          />
        }
        label={
          <Typography variant="body2" color={isEnabled ? 'text.primary' : 'text.secondary'}>
            {label}
          </Typography>
        }
      />
      {isEnabled && (
        <Box sx={{ mt: 1, maxWidth: 200 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Reason</InputLabel>
            <Select
              disabled={isLoading}
              value={currentReason}
              label="Reason"
              onChange={(e) => handleReasonChange(e.target.value)}
              sx={{ fontSize: '0.875rem' }}
            >
              {reasonOptions.map((option) => (
                <MenuItem
                  key={option.key}
                  value={option.key}
                  sx={{ fontSize: '0.875rem' }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </Stack>
  )
}

export default BeneficialOwners
